module.exports = __webpack_public_path__ + "static/img/04.790e339.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wench/04.jpg
// module id = HoKA
// module chunks = 1